import { ChatLastMessageModel } from "api";
import { buildQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { body, request } from "services/request";
import { getCounts } from "./books/chats";

const resource = "api/aggregationChats";
const STEP = 10;

const messagesQuery = {
    top: STEP,
    orderBy: ["createdAt desc", "id desc"],
};

const getChatMessages = ({ queryFilter, ...params }: OdataFilters, chatId: number) => {
    const qp = new URLSearchParams(queryFilter as URLSearchParams);
    const query = buildQuery({ ...messagesQuery, ...params }).substr(1);
    const queryString = [qp.toString(), query].filter((item) => item.length).join("&");
    return request(`${resource}/getChatMessages/${chatId}?${queryString}`, { method: "GET" });
};

const index = (props: OdataFilters): any => {
    const { queryFilter, preparedFilter, maxCount, ...params } = props;

    const queryArr = Object.entries((queryFilter || {}) as { [x: string]: [] }).reduce(
        (acc, [key, val]) => {
            if (Array.isArray(val)) {
                return acc.concat(val.map((v) => [key, String(v)]));
            } else {
                return acc.concat([[key, String(val)]]);
            }
        },
        [] as Array<[string, string]>,
    );

    let qp = new URLSearchParams(queryArr).toString();
    let query = queryCollection(params, {
        filter: preparedFilter,
        orderBy: ["isFavorite desc", "hasMessages desc", "lastMessageDate desc"],
    });
    if (qp.length) {
        query = `&${query.substr(1)}`;
        qp = `?${qp}`;
    }
    const { start, length } = params as { start: number; length: number };
    return request(`${resource}/getlist${qp}${query}`, { method: "GET" }).then((res: ChatLastMessageModel[]) => {
        if (!res) {
            return res;
        }
        if (res.length > 0 || start === 0) {
            return { data: res, ...getCounts(start, length, maxCount!, res.length) };
        } else {
            return index({ ...props, start: start - length, maxCount: start });
        }
    });
};

const getChatInfo = (id: number) => request(`${resource}/getChatInfo/${id}`, { method: "GET" });
const getUnreadMessagesCount = (id: number) => request(`${resource}/getUnreadMessagesCount/${id}`, { method: "GET" });
const getChatCountWithUnreadMessages = () => request(`${resource}/getChatCountWithUnreadMessages`, { method: "GET" });
const sendMessage = (params: {}) => request(`${resource}/sendMessage`, body(params));
const sendFile = (params: {}) => request(`${resource}/sendFileMessage`, params);
const addChatToFavorites = (params: {}) => request(`${resource}/addChatToFavorites`, body(params));
const removeChatFromFavorites = (params: {}) => request(`${resource}/removeChatFromFavorites`, body(params));
const setMessagesAsRead = (params: {}) => request(`${resource}/setMessagesAsRead`, body(params));

export {
    STEP,
    index,
    getChatMessages,
    sendMessage,
    sendFile,
    getChatInfo,
    getUnreadMessagesCount,
    getChatCountWithUnreadMessages,
    setMessagesAsRead,
    addChatToFavorites,
    removeChatFromFavorites,
};
